const IS_LATERAL_MENU_OPEN = (state, isLateralMenuOpen) => {
  state.isLateralMenuOpen = isLateralMenuOpen;
};

export default {
  IS_LATERAL_MENU_OPEN,
};
